<script>
export default {
  name: "CaseStudySection",
  props: {
    reverse: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    }
  }
};
</script>

<template>
  <div class="flex case-study-section" :class="{ 'flex-row-reverse': reverse }">
    <div class="w-7/12 image-container">
      <slot name="image" />
    </div>
    <div class="flex flex-col justify-center text-container">
      <h3>{{ title }}</h3>
      <p>{{ description }}</p>
      <div>
        <a class="btn" href="/">Read more</a>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.text-container {
  max-width: 20%;
  min-width: 350px;
}

.image-container {
  background-color: var(--light-purple);
  height: 528px;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 0px 5px 5px 0px;
  margin-right: 43px;
  position: relative;
}

.flex-row-reverse .image-container {
  margin-left: 43px;
  margin-right: 0;
  border-radius: 5px 0px 0px 5px;
}

.case-study-section {
  h3 {
    font-family: Lora;
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 41px;
  }

  p {
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .btn {
    color: var(--dark-purple);
    font-family: Open Sans;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 27px;
    padding: 10px 24px;
    border: 2px solid var(--dark-purple);
    border-radius: 4px;
  }
}
</style>
